import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import 'react-lazy-load-image-component/src/effects/blur.css';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InView } from 'react-intersection-observer';
import { UserActions } from '../../store/ducks/user';
import PrivateCard from './PrivateCard';
import { API_URL_IMAGES } from '../../utils/constants';
import CardImgDefault from './CardImgDefault';
import { Creators as CourseActions } from '../../store/ducks/newCourse/actions';
import { navigateToCourse } from '../../utils/courseNavigation';


const Loader = () => (
  <ContentLoader
    speed={2}
    width="100%"
    height={132}
    viewBox="0 0 400 132"
    background-color="#f3f3f3"
    foreground-color="#ecebeb"
  >
    <rect x="0" y="26" rx="3" ry="3" width="200" height="6" />
    <rect x="0" y="56" rx="3" ry="3" width="100%" height="6" />
    <rect x="0" y="72" rx="3" ry="3" width="100%" height="6" />
    <rect x="0" y="88" rx="3" ry="3" width="100%" height="6" />
    <rect x="0" y="104" rx="3" ry="3" width="100%" height="6" />
    <rect x="0" y="120" rx="3" ry="3" width="100%" height="6" />
  </ContentLoader>
);

const ContainerLoader = styled.div`
  background: rgba(255, 255, 255, 0.3);
  padding: 10px;
`;

class CardCurso extends PureComponent {
  static contextTypes = {
    router: PropTypes.shape()
  };

  state = {
    urlImg: ''
  };

  componentWillMount() {
    this.checkImgExists();
  }


  redirect = e => {
    const { router } = this.context;
    const { setCourseSelected, toggleModalRestrictLitPass, toggleModalRestrict, course, talks } = this.props;
    const litpass = localStorage.getItem('litpass');
    const showLock = course.lockedCourse;
    const id = course.idCourse || course.attach.id;
    const classe = e.target.className.split(' ');
    if (showLock) {
      try {
        const hasValidLitpass = litpass && litpass !== 'null' && litpass !== 'undefined' && litpass !== '' && JSON.parse(litpass);
        if (course.lockedCourse && hasValidLitpass) {
          toggleModalRestrictLitPass(true);
        } else {
          toggleModalRestrict(true);
        }
      } catch (error) {
        toggleModalRestrict(true);
      }
    } else if (!classe.includes('fa-thumbs-down') && !classe.includes('fa-thumbs-up')) {
      if (talks) {
        setCourseSelected(course.attach);
      }
      navigateToCourse(id, course.type, {
        history: router.history,
        useReplace: true,
        state: talks ? { talks } : undefined,
      });
    }
  };

  checkImgExists = () => {
    const { talks, course } = this.props;
    const { courseImageUrl } = course;
    let urlImg = '';
    if (courseImageUrl) {
      urlImg = courseImageUrl;
    } else {
      urlImg = talks
        ? `${API_URL_IMAGES}images/capa/video/${course.attach.id}/${course.thumbURL}`
        : `${API_URL_IMAGES}images/courses/${course.idCourse}.jpg`;
    }
    this.setState({ urlImg });
  };

  render() {
    const { course, talks } = this.props;
    const {
      urlImg
    } = this.state;
    const freeUser = JSON.parse(localStorage.getItem('freeUser'));
    const showLock = (freeUser && !course.freeCourse) || course.lockedCourse;
    return (
      <div>
        <div className="slider_media">
          {showLock && <PrivateCard />}
          {urlImg ? (
    <InView
      triggerOnce
      threshold={0.1}
    >
      {({ inView, ref }) =>
        inView ? (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          <img
            ref={ref}
            src={urlImg}
            alt={course.curso}
            style={{ width: '100%' }}
            onClick={this.redirect}
          />
        ) : (
          <div ref={ref}>
            <ContainerLoader>
              <Loader />
            </ContainerLoader>
          </div>
        )
      }
    </InView>
  ) : (
            <CardImgDefault redirect={this.redirect} course={course} />
          )}
          
        </div>
        <div role="presentation" className="slider_info" onClick={this.redirect}>
          <div className={`d-flex align-items-center ${showLock ? 'justify-content-between' : 'justify-content-end'}`}>
            {showLock && <PrivateCard />}
          </div>
          <div role="presentation" className="slider_title" onClick={this.redirect}>
            <span className="d-block font-weight-bold">
              {talks ? course.attach.attachmentName : course.curso}
            </span>
            
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { ...CourseActions, ...UserActions.ProfileActions },
    dispatch
  );

export default connect(null, mapDispatchToProps)(CardCurso);
